var map = {
	"./aldo.png": 9958,
	"./logo.png": 6338,
	"./logo1.png": 5470,
	"./ok.png": 47,
	"./stamp.png": 5140,
	"./suzuki.png": 6962,
	"./x.png": 6892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;